var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalBranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0833 6.37601V26.7752H0.868164V6.37601H22.0833Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7905 0.66423C11.3863 0.66423 7.80423 4.17085 7.80423 8.48324V12.5631L4.13238 8.89326L2.97778 10.0479L8.64264 15.6903L14.2626 10.0479L13.108 8.89326L9.43616 12.5794V8.48324C9.43616 5.07045 12.292 2.29616 15.7905 2.29616H22.0837V0.66423H15.7905Z",
    fill: "#FFC8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalBranding);
export default __webpack_public_path__ + "static/media/InternalBranding.c439548014f3ef75b9c9b8f872218ffd.svg";
export { ForwardRef as ReactComponent };